import script from "./GithubAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./GithubAuth.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__